const config = {
  rowSelection: false,
  columns: [
    {
      title: '变更时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 140,
    },
    {
      title: '责任人',
      dataIndex: 'createdByName',
      width: 140
    },
    {
      title: '业务操作',
      dataIndex: 'operationTypeName',
      width: 140,
    },
    {
      title: '退款申请单号',
      dataIndex: 'refundApplyBillNo',
      width: 120,
    },
    {
      title: '门店',
      dataIndex: 'companyName',
      width: 120,
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      width: 120,
    },
    {
      title: '客户开户名',
      dataIndex: 'accountName',
      width: 120,
    },
    {
      title: '开户银行网点',
      dataIndex: 'bankAddress',
      width: 120,
    },
    {
      title: '银行网点联行号',
      dataIndex: 'bankNetworkNumber',
      width: 120,
    },
    {
      title: '开户银行卡号',
      dataIndex: 'accountNumber',
      width: 120,
    },
  ],
  search: [
    {
      name: 'refundApplyBillNo',
      label: '退款申请单号',
      placeholder: '退款申请单号',
    },
    {
      name: 'customerName',
      label: '客户姓名',
      placeholder: '客户姓名',
    },
    {
      name: "companyCode",
      label: "门店",
      itemType: "select",
      key: "orgId",
      labelKey: "companyName",
      data: "orgCompanyArr"
    }
  ],
  footer: []
}
export default config
